import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import type {
    BatchFileUploadUrlsData,
    BatchFileUploadUrlsBody,
} from 'api/dist/routes/organization/[organization_id]/brands/[brand_slug]/nodes/batch-file-upload-urls'

export type IBatchGetUploadFileUrlsMutationParams = {
    organizationId: string
    brandSlug: string
    fileNames: string[]
}

export type IBatchFileUploadUrlItem = BatchFileUploadUrlsData[number]

export class BatchGetUploadFileUrlsMutation {
    static async call(api: IApi, { organizationId, brandSlug, ...params }: IBatchGetUploadFileUrlsMutationParams) {
        return api
            .post<
                BatchFileUploadUrlsData,
                BatchFileUploadUrlsBody
            >(`/organization/${organizationId}/brands/${brandSlug}/nodes/batch-file-upload-urls`, params)
            .then((res) => res.data)
    }
}

export function useBatchGetUploadFileUrlsMutation() {
    const { api, apiParams } = useApiToolbox()

    return useApiMutation({
        mutationFn: (params: Omit<IBatchGetUploadFileUrlsMutationParams, 'brandSlug' | 'organizationId'>) =>
            BatchGetUploadFileUrlsMutation.call(api, {
                organizationId: apiParams.organizationId,
                brandSlug: apiParams.brandSlug,
                ...params,
            }),
    })
}
